var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#96E8A6;}\n\t.st1{fill:#272727;}\n}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 45,
    width: 45,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_5",
    height: 15,
    width: 12,
    className: "st0",
    y: 15,
    x: 15
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_8",
    d: "m30.55,23.06c0,1.57 -0.23,3.01 -0.68,4.31c-0.46,1.31 -1.11,2.42 -1.98,3.34c-0.86,0.93 -1.89,1.64 -3.1,2.15c-1.2,0.51 -2.55,0.76 -4.05,0.76c-1.47,0 -2.81,-0.25 -4.01,-0.76c-1.2,-0.51 -2.24,-1.22 -3.1,-2.15c-0.86,-0.92 -1.53,-2.04 -2.01,-3.34c-0.48,-1.3 -0.72,-2.74 -0.72,-4.31c0,-1.57 0.25,-3 0.74,-4.29c0.49,-1.29 1.18,-2.39 2.05,-3.31c0.87,-0.91 1.91,-1.62 3.12,-2.13c1.2,-0.51 2.51,-0.76 3.93,-0.76c1.44,0 2.77,0.25 3.97,0.76c1.2,0.51 2.24,1.22 3.1,2.13c0.86,0.91 1.53,2.01 2.01,3.31c0.49,1.29 0.73,2.72 0.73,4.29zm-5.78,0c0,-1.75 -0.35,-3.12 -1.04,-4.12c-0.7,-1 -1.69,-1.5 -2.98,-1.5c-1.29,0 -2.29,0.5 -3,1.5c-0.71,1 -1.06,2.38 -1.06,4.12c0,1.75 0.35,3.14 1.06,4.16c0.71,1.03 1.71,1.54 3,1.54c1.29,0 2.29,-0.51 2.98,-1.54c0.7,-1.03 1.04,-2.41 1.04,-4.16z",
    className: "st1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOLogo);
export default __webpack_public_path__ + "static/media/o_logo.b785d9684dd24e7bc4032951cfbf6832.svg";
export { ForwardRef as ReactComponent };